module.exports = __webpack_public_path__ + "img/電気回路_3_6_2.318dc670.png";